export interface IProps {
	onSave: (filter: object) => void;
	dataFilter: IFilter;
}

export interface IFilter {
	descricao: string;
	tipo: string;
	dataInicial: string;
	dataFinal: string;
}

export interface ChipData {
  id: string;
  value: string;
}

export const filters: IFilter = {
  descricao: '',
  tipo: '',
  dataInicial: '',
  dataFinal: ''
}